import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PHONE = "6362915761";
export const WHATSAPP = "916362915761";
export const CATALOGUE_URL = "https://wa.me/c/916362915761";

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imageUrl = (path) => `${API}/images/${path}`;

export const shareUrl = (id) => `${API}/cars/${id}/share`;

export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const formatPrice = (n) => {
  if (n == null) return "";
  return "₹" + Number(n).toLocaleString("en-IN");
};

export const formatKms = (n) => Number(n).toLocaleString("en-IN") + " km";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
